import { createModel } from '@/store/tools';

const url = '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum';

const model = {
    namespace: 'versions',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getVersionList': T('getVersionList'),
            'getVersionInfo': T('getVersionInfo'),
            'getAppTypes': T('getAppTypes'),
            'getSystemTypes': T('getSystemTypes'),
            'getUpdateTypes': T('getUpdateTypes'),
            'getAboutUsInfo': T('getAboutUsInfo'),
        },
        actions: {
            'getVersionList': A('getVersionList'),
            'getVersionInfo': A('getVersionInfo'),
            'getAppTypes': A('getAppTypes'),
            'getSystemTypes': A('getSystemTypes'),
            'getUpdateTypes': A('getUpdateTypes'),
            'getAboutUsInfo': A('getAboutUsInfo'),
        },
        sagas: {
            'getVersionList': S('getVersionList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AppVersionMisService.listAppVersionManage'),
            'getVersionInfo': S('getVersionInfo', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AppVersionMisService.selectByPrimaryKey'),
            'getAppTypes': S('getAppTypes', url),
            'getSystemTypes': S('getSystemTypes', url),
            'getUpdateTypes': S('getUpdateTypes', url),
            'getAboutUsInfo': S('getAboutUsInfo', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.listAdminParamByParamType'),
        },
        reducers: {
            'versionList': R('getVersionList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'versionInfo': R('getVersionInfo', { appType: {}, systemType: {}, updateMode: {} }),
            'appTypes': R('getAppTypes', []),
            'systemTypes': R('getSystemTypes', []),
            'updateTypes': R('getUpdateTypes', []),
            'aboutUsInfo': R('getAboutUsInfo', []),
        }
    })
};
export default createModel(model);